import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import "../../styles/pages/aboutus.css";
import Process from "../module/Process";
import MissionIcon from "../module/MissionIcon";
import BlinkingEyeIcon from "../module/BlinkingEyeIcon";

import bg from "../../assets/images/img/bg.webp";
import bg2 from "../../assets/images/img/bg-2.webp";
import arrow from "../../assets/images/img/downarrow.webp";
import us2 from "../../assets/images/img/us2.jpg";

export default function AboutUs() {
  useScrollReveal("slide-from-left");
  useScrollReveal("slide-from-right");
  useScrollReveal("drop-from-top");
  return (
    <>
      <div className="main-wrapper">
        <img
          alt="scrollDown"
          src={bg2}
          className="landing__image-background-2 image-background slide-from-left"
        />
        <div
          className="rotated-text"
          onClick={() => (window.location.href = "#scroll")}
          style={{ cursor: "pointer" }}
        >
          <img
            src={arrow}
            alt="downarrow"
          />
          <h4>{' '}scroll down</h4>
        </div>

        <div className="section__landing about-page">
          <picture>
            <source
              media="(max-width: 650px)"
              srcSet={bg}
            />
            <img
              alt="container background"
              src={bg}
              className="landing__image-background-1 image-background slide-from-right"
            />
          </picture>
          <div className="container">
            <div className="logo-gradient"></div>
            <div className="content slide-from-left" style={{ width: "100%", maxWidth: 560 }}>
              <h1 style={{ marginBottom: 30 }}>
                Creating purposeful and impactful digital solutions.
              </h1>
              <p style={{ marginBottom: 40 }}>
                Excellence, innovation, and a commitment to action—these are the
                cornerstones of Genvix Tech. Discover the impact we can make for
                your business today.
              </p>
              <button
                onClick={() => (window.location.href = "/services")}
                className="btn blue"
              >
                Our Services
              </button>
            </div>
          </div>
        </div>

        <div className="container container__about-scroll" id="scroll">
          <h5 className="drop-from-top">About us</h5>
          <h2 className="drop-from-top" style={{ marginBottom: 30 }}>
            Comprehensive digital solutions for your success.
          </h2>
          <div className="container__text">
            <p className="slide-from-left">
              At Genvix Tech, we pride ourselves on a personalized approach for
              every client, ensuring strong commitment and deep engagement
              throughout our collaborations. Whether we’re developing your website
              or crafting a custom application, you stay informed at every step,
              with transparent updates and opportunities to review and approve
              progress. For digital marketing campaigns, we provide live
              performance reports so you can track results in real time. Our work
              is grounded in expertise, experience, and continuous learning across
              all the services we offer.
            </p>
            <p className="slide-from-right">
              We support our clients beyond project completion with long-term
              partnerships that include post-launch maintenance, training, and
              technical assistance. If desired, we can also fully manage your
              digital assets—be it websites, apps, or social media
              platforms—allowing you to focus on your core business. Many clients
              continue to rely on us months or even years after project delivery,
              confident that we’re here to provide ongoing support whenever
              needed. At Genvix Tech, you’re never left on your own.
            </p>
          </div>
        </div>

        <div className="section section__ceo">
          <div className="about__ceo">
            {/* <div className="about__ceo-text">
            <span className="about__ceo-title">
              Genvix Tech Private Limited
               <span>
                <span className="about__ceo-separator">|</span> CEO
              </span> 
            </span>
          </div> */}
            <img
              loading="lazy"
              src={us2}
              alt="Genvix Tech team"
              className="image__about-patryk slide-from-left"
            />
          </div>

          <div className="container__ceo-text">
            <h2 className="slide-from-right" style={{ marginBottom: 30 }}>
              Our certified team of specialists is dedicated to providing expert
              solutions for all your needs.
            </h2>
            <p className="slide-from-right">
              At Genvix Tech, we specialize in delivering high-quality IT
              solutions—including web and mobile application development,
              enterprise software, UI/UX design, digital marketing, and graphic
              design—to help businesses enhance their online presence. Our team of
              qualified specialists focuses on their areas of expertise, ensuring
              each project is handled by trained and certified professionals
              dedicated to excellence.
            </p>
            <div className="about__ceo-mission-icons slide-from-bottom">
              <div className="about__mission-card about__mission-card--left">
                <MissionIcon />
                <div className="about__card-content">
                  <h6 className="about__ceo-subtitle">Our mission</h6>
                  <p>
                    We deliver expert internet marketing and comprehensive IT
                    solutions, creating custom websites and apps that drive growth
                    and enhance user experience.
                  </p>
                </div>
              </div>
              <div className="about__mission-card about__mission-card--right">
                <div className="about__card-content">
                  <h6 className="about__ceo-subtitle">Our Vision</h6>
                  <p>
                    To boost every brand’s online presence with tailored marketing
                    strategies that build engagement, lasting connections, and
                    sustainable growth.
                  </p>
                </div>
                <BlinkingEyeIcon />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Process />
    </>
  );
}
